var _defs, _circle, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgBreeds(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icons-RZ_Blau",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 50 50",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#92bcbf;}.cls-2{fill:#223656;}"))), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 25,
    cy: 25,
    r: 24
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.64,39.63l2.91-1.6c.9-.49,2-.49,2.9,0l2.91,1.6c.98,.54,2.18,.49,3.11-.13l3.09-2.03c1.49-.98,2.39-2.64,2.39-4.42h0c0-1.56-.69-3.03-1.88-4.04l-9.12-7.71c-1.12-.95-2.77-.95-3.89,0l-9.12,7.71c-1.19,1.01-1.88,2.49-1.88,4.04h0c0,1.78,.9,3.44,2.39,4.42l3.09,2.03c.93,.61,2.13,.66,3.11,.13Z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 13.38,
    cy: 21.91,
    rx: 3.38,
    ry: 3.97
  }), /*#__PURE__*/React.createElement("ellipse", {
    className: "cls-2",
    cx: 36.62,
    cy: 21.91,
    rx: 3.38,
    ry: 3.97
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M20.07,18.82c2.15,0,3.9-1.98,3.9-4.41s-1.74-4.41-3.9-4.41-3.9,1.98-3.9,4.41,1.74,4.41,3.9,4.41Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M29.84,18.82c2.15,0,3.9-1.98,3.9-4.41s-1.74-4.41-3.9-4.41-3.9,1.98-3.9,4.41,1.74,4.41,3.9,4.41Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgBreeds);
export default __webpack_public_path__ + "static/media/breeds.6320c7aa63798fdc21c82257f3e39b57.svg";
export { ForwardRef as ReactComponent };